import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  getPrefixesFromId,
  getPriceSourcesFromId,
  getPriceDestinationsFromId,
  editFromId,
  newItem
} from '../../API/PhoneZones';
import {
  form,
  prefixForm,
  priceSourceForm,
  priceDestinationForm
} from '../Form/phoneZones';
import { form as searchForm } from '../Form/Search/phoneZones';

import { phoneZone as routes } from '../Route/routes';

export const conf = {
  index: {
    pageTitle: strings.common.homepage.phoneZone,

    id: "phoneZone",
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.label) {
        result["label"] = search.label;
      }
      return result;
    },

    availableItemDisplay:['line'],
    itemDisplay: {
      line: {
        label: (item) => `${item["label"]}`
      },
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.phoneZone,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "label",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.phoneZone.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (entity) => {},
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_CDR_CONFIGURATION'],
        editable: ['ROLE_CDR_CONFIGURATION']
      },
      prefix: {
        title: strings.phoneZone.tab.prefix,
        type: 'form',
        form: prefixForm,

        onUpdateItem: (data) => {},

        apiGet: getPrefixesFromId,

        role: ['ROLE_CDR_CONFIGURATION'],
        editable: false
      },
      priceSource: {
        title: strings.phoneZone.tab.priceSource,
        type: 'form',
        form: priceSourceForm,

        onUpdateItem: (data) => {},

        apiGet: getPriceSourcesFromId,

        role: ['ROLE_CDR_CONFIGURATION'],
        editable: false
      },
      priceDestination: {
        title: strings.phoneZone.tab.priceDestination,
        type: 'form',
        form: priceDestinationForm,

        onUpdateItem: (data) => {},

        apiGet: getPriceDestinationsFromId,

        auth: ['ROLE_CDR_CONFIGURATION'],
        editable: false
      },
    }
  },
  new: {
    pageTitle: strings.phoneZone.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (phoneZone) => {},
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
